<template>
  <app-content>
    <page-title>Corona-Informationen</page-title>
    <main id="corona">
      <div class="container">
        <p>Wir sind sehr dankbar und freuen uns, dass unsere Hochzeitsfeier stattfinden kann und wir
          mit so vielen Leuten feiern dürfen. In der aktuellen Situation bitten wir euch, eine
          Extraportion Humor und gute Laune mitzubringen, damit wir gemeinsam einen tollen Abend
          verbringen können. Gleichzeitig ist es uns wichtig, kein unnötiges Risiko einzugehen,
          deshalb wird manches anders ablaufen, als es das unter normalen Umständen würde.</p>
        <p><strong>Daher bitten wir Euch, zum Schutz aller Gäste die folgenden Informationen zu
          beachten.</strong></p>
        <p>Wer es für sich selbst nicht verantworten kann, so einer großen Veranstaltung
          beizuwohnen, darf sich frei fühlen, aus diesem Grund zu Hause zu bleiben. Wir haben dafür
          vollstes Verständnis. Wir bitten dich außerdem, falls du Krankheitssymptome haben
          solltest, nicht zur Hochzeit zu kommen, um andere Gäste zu schützen.</p>
        <section>
          <h2>Traugottesdienst</h2>
          <ul>
            <li>Damit alle Gäste nacheinander an ihren Platz geführt werden können, bitten wir Euch,
              bereits mindestens 30 Minuten vor Beginn der Trauung bei der Kirche zu sein. Während
              der Wartezeit soll jederzeit der Sicherheitsabstand zu umstehenden Personen
              eingehalten werden.</li>
            <li>In der Kirche darf der Mund-Nasen-Schutz erst dann abgenommen werden, wenn Ihr euren
              Plaz eingenommen habt. Während des Gottesdienstes darf der Platz nicht verlassen
              werden.</li>
            <li>Während des Gottesdienstes ist nur leises Singen oder Summen erlaubt. Es wird
            empfohlen, dabei einen Mundschutz zu tragen.</li>
          </ul>
        </section>
        <section>
          <h2>Kaffeetrinken</h2>
          <ul>
            <li>Aus Hygienegründen werden am Buffet eingewiesene Helfer das Essen ausgeben,
              Selbstbedienung ist nicht erlaubt.</li>
            <li>Am Buffet muss ein Mund-Nasen-Schutz getragen werden und, soweit möglich, Abstand
              von anderen Personen und den Buffet-Helfern gehalten werden</li>
            <li>Auch während des Essens und Trinkens sollte der Sicherheitsabstand eingehalten
              werden</li>
          </ul>
        </section>
        <section>
          <h2>Abendessen & Feier</h2>
          <ul>
            <li>Die Vorspeisen werden am Tisch serviert.</li>
            <li>Anschließend werden die Tische nacheinander zum Buffet gebeten. Die Wartezeit dürft
              ihr euch gern mit angeregten Gesprächen am Tisch vertreiben. Während des Gangs zum
              Buffet muss ein Mund-Nasen-Schutz getragen werden.</li>
            <li>Beim Verlassen des Platzes, insbesondere bei Gesprächen, muss der Mund-Nasen-Schutz
              getragen werden.</li>
            <li>Es ist leider nicht gestattet, die Plätze zu wechseln. Jeder sollte an seinem
              zugewiesenen Platz sitzen bleiben. Gespräche sind selbstverständlich erlaubt, diese
              können im Stehen und mit Sicherheitsabstand geführt werden.</li>
          </ul>
        </section>
        <section>
          <h2>Party & Tanz</h2>
          <ul>
            <li>Paartanz ist erlaubt, jedoch nur mit dem eigenen Partner. Partnerwechsel sind aus
              Sicherheitsgründen nicht erlaubt.</li>
            <li>Beim Tanz sollte der Sicherheitsabstand zu anderen Personen stets eingehalten
              werden, die einzige Ausnahme bildet der Tanzpartner.</li>
          </ul>
        </section>
      </div>
    </main>
  </app-content>
</template>

<script>
import AppContent from '@/components/technical/AppContent.vue';
import PageTitle from '@/components/PageTitle.vue';

import WPlannerApi from '@/mixins/wplanner-api';

export default {
  name: 'Corona',
  components: { PageTitle, AppContent },
  mixins: [WPlannerApi],

  data() {
    return {
    };
  },
};
</script>

<style lang="scss">
  main#corona {
    flex: 1 0 auto;
    padding: 1.5rem;

    text-align: left;
  }
</style>
